import { BrowserRouter, Routes, Route } from "react-router-dom";
import SalesRoute from "./components/SalesRoute";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";
import LegalPage from "./pages/LegalPage";
import Intake from "./pages/Intake";
import ErrorBoundary from "./components/ErrorBoundary";

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
        <Route path="/" element={<SalesRoute slug="home" variant="full" />} />
        <Route path="/performance-reset" element={<SalesRoute slug="performance-reset" variant="full" />} />
        <Route path="/performance-resetads" element={<SalesRoute slug="performance-resetads" variant="ads" />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<LegalPage slug="privacy" title="Privacy Policy" />} />
        <Route path="/terms" element={<LegalPage slug="terms" title="Terms & Conditions" />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="*" element={<SalesRoute slug="home" variant="full" />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
